import {
  AutocompleteArrayInput,
  Datagrid,
  EditButton, FieldProps,
  InputProps,
  List,
  NumberField,
  ReferenceArrayInput,
  SimpleForm,
  TextField,
  TextInput,
  useRecordContext,
} from 'react-admin';
import * as React from 'react';
import { IfCanAccess } from '@react-admin/ra-rbac';
import { useEffect, useState } from 'react';
import { useRedirect } from 'ra-core';
import QRCode from 'qrcode.react';
import _ from 'lodash';
import SearchFields from '../components/fields/Filters';
import { DEVICE_REGISTRATION_API_URL, LIST_DEBOUNCE } from '../../../config';
import { exporter } from '../../../utils/customExporter';
import CustomBulkActionButtons from '../../../components/buttons/CustomBulkActionButtons';
import { CreateWithSuccess } from '../../../components/baseForms/CreateWithSuccess';
import ReferenceArrayFieldNullable from '../../../components/fields/ReferenceArrayFieldNullable';
import { DateFieldWithTime } from '../../../components/fields/DateFieldWithTime';
import { EditWithSuccess } from '../../../components/baseForms/EditWithSuccess';
import { HasRoles } from '../../../components/HasRoles';
import { AuditlogButton } from '../components/buttons/AuditlogButton';
import { httpClient } from '../../../utils/httpClient';
import authProvider from '../../../utils/authProvider';

const deviceRegistrationApiUrl = DEVICE_REGISTRATION_API_URL;

const transform = (data: Record<string, any>) => {

  return {
    ...data,
    profile: {
      ...data.profile,
      assetGroups: data.profile.assetGroups.map((group: any) => {

        return {
          _id: group,
          _ref: 'AssetGroup',
        };

      }),
      configGroups: data.profile.configGroups.map((group: any) => {

        return {
          _id: group,
          _ref: 'ConfigGroup',
        };

      }),
      assetGroupLimit: data.profile.assetGroupLimit.map((group: any) => {

        return {
          _id: group,
          _ref: 'AssetGroup',
        };

      }),
    },
  };

};
export const RegistrationTemplateList = () => {

  const redirect = useRedirect();
  const isDevAdmin = authProvider.isDeveloperAdmin();
  if (!isDevAdmin) {

    redirect('/');

  }
  return (
    <List filters={SearchFields} debounce={LIST_DEBOUNCE} exporter={exporter} title="resources.registration-templates.text.title">
      <Datagrid rowClick="toggleSelection" bulkActionButtons={<CustomBulkActionButtons/>}>
        <TextField source={'name'} label={'general.fields.name'}/>
        <NumberField source={'numberUsed'} label={'resources.registration-templates.fields.numberUsed'}/>
        <ReferenceArrayFieldNullable reference={'asset-groups'} source={'profile.assetGroups'}/>
        <ReferenceArrayFieldNullable
          reference={'client-config/groups'}
          source={'profile.configGroups'}
        />
        <ReferenceArrayFieldNullable
          reference={'asset-groups'}
          source={'profile.assetGroupLimit'}
        />
        <DateFieldWithTime source="createdAt" label="general.fields.createdAt" timeOnHover={true}/>
        <DateFieldWithTime source="updatedAt" label="general.fields.updatedAt" timeOnHover={true}/>
        <IfCanAccess action="edit">
          <EditButton/>
        </IfCanAccess>
        <HasRoles anyOf={['developer_admin']}>
          <AuditlogButton/>
        </HasRoles>
      </Datagrid>
    </List>
  );

};

export const LegacyConfigGroupsInput = (props: InputProps) => {

  const [availableGroups, setAvailableGroups] = useState<any[]>([]);

  useEffect(() => {

    const getAvailableGroups = async () => {

      const groupRequest = await httpClient(`${deviceRegistrationApiUrl}/v3/deployment/device/groups`);
      setAvailableGroups(groupRequest.json.groups.sort().map((group: string) => ({ value: group, label: group })));

    };

    getAvailableGroups();

  }, []);

  return (
    <AutocompleteArrayInput
      source={props.source}
      choices={availableGroups}
      optionValue="value"
      optionText="label"
      disableCloseOnSelect
      autoHighlight
      blurOnSelect={false}
    />
  );

};

export const RegistrationTemplateCreate = () => {

  const redirect = useRedirect();
  const isDevAdmin = authProvider.isDeveloperAdmin();
  if (!isDevAdmin) {

    redirect('/');

  }
  return (
    <CreateWithSuccess title="resources.registration-templates.text.title" transform={transform}>
      <SimpleForm>
        <TextInput source={'name'} label={'general.fields.name'} required/>
        <ReferenceArrayInput source={'profile.assetGroups'} reference={'asset-groups'}/>
        <ReferenceArrayInput source={'profile.configGroups'} reference={'client-config/groups'}/>
        <LegacyConfigGroupsInput source={'profile.legacyConfigGroups'}/>
        <ReferenceArrayInput source={'profile.assetGroupLimit'} reference={'asset-groups'}/>
      </SimpleForm>
    </CreateWithSuccess>
  );

};

const QrCodeField = (props: FieldProps) => {

  const record = useRecordContext();
  const code = _.get(record, props.source);
  if (!code) {

    return null;

  }
  return (
    <QRCode includeMargin={false} bgColor={'#F1F2F2'} id="qrCodeRenderPoster" value={`https://x-guard.nl/app/register?code=${code}`} renderAs={'canvas'} color="white" />
  );

};

export const RegistrationTemplateEdit = () => {

  const redirect = useRedirect();
  const isDevAdmin = authProvider.isDeveloperAdmin();
  if (!isDevAdmin) {

    redirect('/');

  }
  return (
    <EditWithSuccess title="resources.registration-templates.text.title" transform={transform}>
      <SimpleForm>
        <TextInput source={'name'} label={'general.fields.name'} required/>
        <ReferenceArrayInput source={'profile.assetGroups'} reference={'asset-groups'}/>
        <ReferenceArrayInput source={'profile.configGroups'} reference={'client-config/groups'}/>
        <LegacyConfigGroupsInput source={'profile.legacyConfigGroups'}/>
        <ReferenceArrayInput source={'profile.assetGroupLimit'} reference={'asset-groups'}/>
        <QrCodeField source={'code'}/>
      </SimpleForm>
    </EditWithSuccess>
  );

};
